<template>
    <div class="bg">
        <div class="main">
            <pdf
                    ref="pdf"
                    :src="pdfSrc"
                    :page="pageNum"
                    @progress="loadedRatio = $event"
                    @num-pages="pageTotalNum=$event"
                    @loaded="loaded"
                    :style="widthStyle"
            ></pdf>
        </div>
        <div class="operation">
            <div class="item">
                <span class="enable" v-if="info==1" @click="toInfo">基本信息</span>
                <span class="disable" v-else>基本信息</span>
            </div>
            <div class="item">
                <span class="enable" v-if="fid==null||fid==''" >身份证正面</span>
                <span class="disable" v-else>身份证正面</span>
                <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange($event,1)" ref="file_f" :disabled="(fid==null||fid=='')?false:true">
            </div>
            <div class="item">
                <span class="enable" v-if="bid==null||bid==''"  >身份证反面</span>
                <span class="disable" v-else>身份证反面</span>
                <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange($event,2)" ref="file_b" :disabled="(bid==null||bid=='')?false:true">
            </div>
            <div class="item">
                <span class="enable" @click="toSign" v-if="sign==null||sign==''">签名</span>
                <span class="disable" v-else>签名</span>
            </div>

        </div>
        <div class="size-wrap">
            <span class="enlarge" @click="scaleD"></span>
            <span class="shrink" @click="scaleX" ></span>
        </div>
        <div class="next-wrap">
            <div>
                <span class="previous" @click="previous()"></span>
            </div>
            <div class="pageIndex">
                <div class="page">{{ pageNum }} / {{ pageTotalNum }}</div>
            </div>
            <div>
                <span class="next" @click="next()" ></span>
            </div>
        </div>
        <div class="sign-wrap" v-if="signShow">
            <Signature @setSign="setSign"></Signature>
        </div>
    </div>
</template>

<script>
    // pdf预览
    import pdf from "vue-pdf";
    import Signature from "../ksd/sign/Signature";
    import {agreementInfo,editId,sign} from "@/assets/js/api";
    import {Indicator} from "mint-ui";
    import OSS from "ali-oss";
    import {getUuid} from "@/assets/util/util";

    export default {
        name: "Home",
        components: {
            pdf,
            Signature
        },
        data() {
            return {
                src: "http://server.iumed.com.cn/plus/u_agreement/getAgreement?agreementId="+this.$route.query.agreementId,
                // src: "http://192.168.2.121:9090/u_agreement/getAgreement?agreementId="+this.$route.query.agreementId,
                // src:"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/talk/pdf/06675359-3b18-4062-a975-c341ed6750e7.pdf",
                currentPage: 0, // pdf文件页码
                pageCount: 0, // pdf文件总页数
                scale: 100,
                pageRotate: 0,
                numPages: null,
                width:1.0,
                signShow:false,
                agreementId:this.$route.query.agreementId,
                fid:"",
                bid:"",
                sign:"",
                info:0,
                ossKeySecret:'gMpwhe9mmsnAxMPvVOc1TqWYkf1iyM',
                ossPrefix:"umed/agreement/id/",
                pageNum: 1,
                pageTotalNum: 0,
                pr:""
            };
        },
        mounted() {
            console.log("pr="+this.pr)
            this.getAgreementInfo();
            this.loading()
        },
        computed: {
            pdfSrc() {
                //处理pdfUrl返回
                let src = pdf.createLoadingTask({
                    url: this.src,
                    // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
                    cMapUrl: "https://ymd-lcc.oss-cn-beijing.aliyuncs.com/cmaps/",
                    cMapPacked: true
                })
                return src;
            },
            widthStyle(){
                return{
                    width:(this.width *100)+"%"
                }
            }
        },
        methods: {
            loading(){
                Indicator.open({
                    text: '加载中',
                    spinnerType: 'fading-circle'
                });
            },
            loaded(){
                Indicator.close()
            },
            toInfo(){
              if(this.pr=="b"){
                  this.$router.push({path:"bAgreementInfo",query:{id:this.agreementId}})
              }  else{
                  this.$router.push({path:"agreementInfo",query:{id:this.agreementId}})
              }
            },
            async getAgreementInfo(){
                let agreementId = this.agreementId
                let pr = this.pr
                console.log(agreementId,"123")
                if(agreementId==null) return
                const res = await agreementInfo({agreementId,pr})
                if(res.data.success){
                    this.fid = res.data.data.fid
                    this.bid = res.data.data.bid
                    this.sign = res.data.data.sign
                    this.info = res.data.data.info
                    this.pr = res.data.data.pr
                }

                console.log(this.src)
                console.log(res)
            },
            fileChange(event,type){
                let _this = this
                let file
                console.log(type,"type")
                if(type==1){
                    file = _this.$refs.file_f.files[0]
                }else{
                    file = _this.$refs.file_b.files[0]
                }

                if(this.info==1){
                    this.$toast("上传身份证前请先完善个人基本信息");
                    return
                }

                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                console.log(file,"file")

                _this.ossUpload(file).then(function (res) {
                    console.log(res,"oss result")
                    Indicator.close();
                    if(type==1){
                        _this.editId(_this.agreementId,res,null)
                    }else{
                        _this.editId(_this.agreementId,null,res)
                    }
                })

            },
            async editId(agreementId,fid,bid){
                const res = await editId({agreementId,fid,bid})

                console.log(res,"99999")

                if(res.data.success){
                    // _this.$router.go(0)//刷新当前页面
                    location.reload()
                    this.$toast("提交成功")
                }else{
                    this.$toast(res.data.message)
                }


            },
            async toSign(){
                if(this.info==1){
                    this.$toast("签名前请先完善个人基本信息");
                    return
                }
                if(this.fid==null||this.fid==""||this.bid==null||this.bid==""){
                    this.$toast("签名前请先上传身份证");
                    return
                }
                this.signShow = true
            },
            setSign(sign){
                this.signShow = false
                console.log("getSetSign---",sign)
                this.signCommit(this.agreementId,sign);
            },
           async signCommit(agreementId,signBase64){
                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                let data ={
                    agreementId:agreementId,
                    signBase64: signBase64
                }

                const res = await sign({data})
                if(res.data.success){
                    Indicator.close()
                    this.$router.go(0)
                }else{
                    Indicator.close()
                    this.$toast(res.data.message)
                }
                console.log(res,"sign res")
            },
            // getNumPages() {
            //     let loadingTask = pdf.createLoadingTask({
            //         url: this.src,
            //         cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
            //         cMapPacked: true
            //     })
            //     loadingTask.promise.then(pdf => {
            //         this.numPages = pdf.numPages
            //     }).catch(err => {
            //         console.error('pdf 加载失败', err);
            //     })
            // },
            // pdf加载时
            loadPdfHandler(e) {
                console.log(e)
                this.currentPage = 1; // 加载的时候先加载第一页
            },
            // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
            changePdfPage(val) {
                if (val === 0 && this.currentPage > 1) {
                    this.currentPage--;
                }
                if (val === 1 && this.currentPage < this.pageCount) {
                    this.currentPage++;
                }
            },
            //放大
            scaleD() {
                this.width+=0.2
            },
            //缩小
            scaleX() {
                if(this.width<=1) return
                this.width-=0.2
            },
            //上一页
            previous(){
                if(this.pageNum==1) return
                let page = this.pageNum
                page = page > 1 ? page - 1 : this.pageTotalNum
                this.pageNum = page
            },
            //下一页
            next(){
                let page = this.pageNum
                page = page < this.pageTotalNum ? page + 1 : 1
                this.pageNum = page
            },
            async ossUpload(file){

                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()
                uuid+=("."+file.name.split(".")[1])
                let key = this.ossPrefix + uuid

                let link=""
                // await client.put(key, file).then(function (res) {
                //
                //     let str = res.res.requestUrls[0]
                //     let status = res.res.status
                //     if(status == 200){
                //         const workLink =  str.split("?")[0];
                //         link = workLink
                //     }else {
                //         this.$toast("上传失败")
                //     }
                // }).catch((err) => {
                //     // Indicator.close();
                //     console.log(err,"异常啦")
                //     this.$toast("照片上传失败，请切换网络重试")
                // })

                await  client.multipartUpload(key, file).then(function(res){
                    var str=res.res.requestUrls[0]
                    console.log(str.split("?")[0])
                    let status = res.res.status
                    if(status == 200){
                        link = str.split("?")[0];
                    }else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    console.log(err)
                })

                return link
            },
        }
    };
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        position: relative;
    }


    .main {
        width: 100%;
        height: 90%;
        overflow: scroll;
        position: relative;
    }

    .operation{
        height: 10%;
        background: #dedede;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .operation span{
        color: #FFF;
        padding: 5px 10px;
        border-radius: 5px;
    }

    .sign-wrap{
        position: absolute;
        width: 90%;
        height: 350px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: #FFF;
        border-radius: 20px;
    .close{
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        position: relative;
        font-weight: normal;
        img{
            position: absolute;
            right: 20px;
            width: 25px;
            height: 25px;
            }
        }
    }

    .enable{
        background: #0a4179;
    }

    .disable{
        background: #999;
    }

    .size-wrap{
        position: absolute;
        bottom: 20%;
        right: 5%;
        span{
            display: block;
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
        }
        .enlarge{
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/umed/agreement/enlarge.png") no-repeat;
            background-size: 100% 100%;
        }
        .shrink{
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/umed/agreement/shrink.png") no-repeat;
            background-size: 100% 100%;
        }
    }

    .item{
        position: relative;
    }

    .file{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }


    .mint-indicator-wrapper {
        z-index: 1000 !important;
    }

    .mint-indicator-mask {
        z-index: 1000 !important;
    }

    .next-wrap{
        position: absolute;
        width: 100%;
        bottom: 12%;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;


        span{
            display: block;
            width: 40px;
            height: 40px;
            margin: 10px ;
        }
        .previous{
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/umed/agreement/arrow-left.png") no-repeat;
            background-size: 100% 100%;
        }
        .next{
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/umed/agreement/arrow-right.png") no-repeat;
            background-size: 100% 100%;
        }

    }

    .pageIndex{
        font-size: 18px;
    }

</style>
